import { NgModule } from '@angular/core';

import { SharedModule} from "../../shared/shared.module";
import { BombasComponent } from './bombas.component';
import { BombaListComponent } from './bomba-list/bomba-list.component';
import { BombaFormComponent } from './bomba-form/bomba-form.component';
import { BombaApiService } from "./shared/bomba-api.service";
import { BombaNavigationService } from "./shared/bomba-navigation.service";
import { BombaService } from "./shared/bomba.service";
import { BombasRoutingModule} from "./bombas-routing.module";
import { BombaAuditoriaListComponent } from "./bomba-auditoria-list/bomba-auditoria-list.component";
import { BombaAuditoriaDetailComponent } from "./bomba-auditoria-detail/bomba-auditoria-detail.component";
import { BombaAuditoriaComponent } from "./bomba-auditoria/bomba-auditoria.component";

@NgModule({
    imports: [
        SharedModule,
        BombasRoutingModule
    ],
    providers: [
        BombaApiService,
        BombaNavigationService,
        BombaService
    ],
    declarations: [
        BombasComponent,
        BombaListComponent,
        BombaFormComponent,
        BombaAuditoriaListComponent,
        BombaAuditoriaDetailComponent,
        BombaAuditoriaComponent
    ]
})
export class BombasModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/bombas/bombas.module.ts
 **/